import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ContentColumns = makeShortcode("ContentColumns");
const Card = makeShortcode("Card");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ContentColumns mdxType="ContentColumns">{[<Card key="ubytovanie" variant="vertical" image="izby/apartman-rodinny.jpg" title="Pohodlie v útulných izbách" to="/ubytovanie/" mdxType="Card">
		Izby a apartmány s nádhernými výhľadmi na priľahlý svah a prírodu.
	</Card>, <Card key="restauracia" variant="vertical" image="restauracia/13.jpg" title="Domáca kuchyňa" to="/restauracia/" mdxType="Card">
		Máme radi naše slovenské jedlá, pripravené doma v kuchyni a s láskou.
	</Card>, <Card key="okolie" variant="vertical" image="okolie/20200516_181238.jpg" title="Relax v srdci prírody" to="/okolie/" mdxType="Card">
		Kamkoľvek len pozriete očarí vás krásna príroda, jej pokoj a ničím nerušené ticho.
	</Card>]}</ContentColumns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      